export default __webpack_public_path__ + "static/media/kpmg.4a1c032e.png";